// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ozg-summary-item',
    emits: ["command"],
    // #endregion
    // #region Properties
    props: {
        page: {
            type: Object,
            required: false,
            default: {}
        },
        schema: {
            type: Object,
            required: false,
            default: {}
        },
        data: {
            type: Object,
            required: false,
            default: {}
        },
        schemaData: {
            type: Object,
            required: false,
            default: {}
        }
    },
    data: () => ({
        isOpen: false
    }),
    // #endregion
    // #region Core
    methods: {
        onExpand() {
            this.isOpen = !this.isOpen;
        },
        onCommand(command, args) {
            this.$emit('command', command, args);
        },
    },
    // #endregion
});
// #endregion
